exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ServiceCardWrapper_component_2Jdp {\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n\n  width: 300px;\n}\n\n.ServiceCardWrapper_isMobile_km4S {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ServiceCardWrapper_component_2Jdp",
	"isMobile": "ServiceCardWrapper_isMobile_km4S"
};